import request from '@/utils/request'

let OcourseApi = {

  /*网课列表*/
  list(data) {
    return request._post('/shop/plus.ocourse.Index/index', data);
},
/*添加网课*/
add(data) {
    return request._post('/shop/plus.ocourse.Index/add', data);
},
/*修改网课*/
edit(data) {
    return request._post('/shop/plus.ocourse.Index/edit', data);
},
/*删除网课*/
del(data) {
    return request._post('/shop/plus.ocourse.Index/del', data);
},
/*网课详情*/
detail(data) {
  return request._post('/shop/plus.ocourse.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ocourse.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ocourse.Setting/getSetting', data, errorback);
    },
    /*修改部分数据*/
editPart(data) {
    return request._post('/shop/plus.ocourse.Index/editPart', data);
},




  /*目录列表*/
  listCatalogue(data) {
    return request._post('/shop/plus.ocourse.Index/indexCatalogue', data);
},
/*添加目录*/
addCatalogue(data) {
    return request._post('/shop/plus.ocourse.Index/addCatalogue', data);
},
/*修改目录*/
editCatalogue(data) {
    return request._post('/shop/plus.ocourse.Index/editCatalogue', data);
},
/*删除目录*/
delCatalogue(data) {
    return request._post('/shop/plus.ocourse.Index/delCatalogue', data);
},
/*目录详情*/
detailCatalogue(data) {
  return request._post('/shop/plus.ocourse.Index/detailCatalogue', data);
},


  /*目录列表*/
  listUrl(data) {
    return request._post('/shop/plus.ocourse.Index/indexUrl', data);
},
/*添加目录*/
addUrl(data) {
    return request._post('/shop/plus.ocourse.Index/addUrl', data);
},
/*修改目录*/
editUrl(data) {
    return request._post('/shop/plus.ocourse.Index/editUrl', data);
},
/*删除目录*/
delUrl(data) {
    return request._post('/shop/plus.ocourse.Index/delUrl', data);
},
/*目录详情*/
detailUrl(data) {
  return request._post('/shop/plus.ocourse.Index/detailUrl', data);
},



    //查询客户以及对应的sku
    getUserAndSku(data){
        return request._post('/shop/plus.ocourse.Index/getUserAndSku',data);
    },
    maKeSkuPrice(data){//单独或者批量定价
        return request._post('/shop/plus.ocourse.Index/maKeSkuPrice',data);
    },

    //获取sku流向记录
    getSkuFlow(data){
        return request._post('/shop/plus.ocourse.Index/getSkuFlow',data);
    },
}
export default OcourseApi;



// WEBPACK FOOTER //
// ./src/api/ocourse.js